import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import FormLabel from '@mui/material/FormLabel'
import Grid from '@mui/material/Grid'
import {IConceptFE} from 'interfaces/IConceptFE'
import {ISavedSearchFE} from 'interfaces/ISavedSearchFE'
import {DropResult} from 'react-beautiful-dnd'
import {emReorderConcepts} from 'utilities/extensionMethods'
import DraggableConceptNotify from '../draggable/DraggableConceptNotify'
import {reorderConcepts} from '../draggable/helpers'

type Props = {
  search: ISavedSearchFE
  searchString?: string
  searchLabel?: string
  stackVertical?: boolean
  chipSize?: 'sm' | 'md' | 'lg' | undefined
  showLabel?: boolean
  ignoredOnly?: boolean
  disabledText?: string
}
// Made this one separate to take dedicated list of concepts instead of using selector and redux on saved search that is set from toolbar
// used when not setting a sved search to the toolbar
export default function DragableConceptsListNotifications({
  search,
  stackVertical,
  chipSize,
  showLabel,
  ignoredOnly,
  disabledText,
}: Props) {
  const orderConcepts = emReorderConcepts(search?.concepts?.map((c) => c as IConceptFE) ?? [])

  const onDragEnd = ({destination, source}: DropResult) => {
    // dropped outside the list
    if (!destination) return
    //don't ned to save when reordering ignore
    if (ignoredOnly) return
    const orderedConcepts = reorderConcepts<IConceptFE>(
      search?.concepts ?? [],
      source.index,
      destination.index
    )
    if (search) {
      search.concepts = orderedConcepts
    }
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box display={'flex'} flexWrap={'wrap'} flexDirection={stackVertical ? 'column' : 'row'}>
          <FormControl component='fieldset'>
            {showLabel && <FormLabel component='legend'>Current Concepts</FormLabel>}
            <DraggableConceptNotify
              disabledText={disabledText}
              search={search}
              items={
                ignoredOnly
                  ? orderConcepts?.filter((i) => i.__lock === 'exclude') ?? []
                  : orderConcepts?.filter((i) => i.__lock !== 'exclude') ?? [] ?? []
              }
              onDragEnd={onDragEnd}
              stackVertical={stackVertical}
              chipSize={chipSize}
            />
          </FormControl>
        </Box>
      </Grid>
    </Grid>
  )
}
